import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../http";

export type UserBalance = {
  token_balance: number;
  plan_balance: number;
  referral_token_balance: number;
};

export function totalBalance({
  token_balance,
  plan_balance,
  referral_token_balance,
}: UserBalance): number {
  if (plan_balance == -1) return -1;
  else return token_balance + plan_balance + referral_token_balance;
}

async function getUserBalance() {
  return await api.detector.get<UserBalance>("v2/ai-detector/balance-calculation");
}

export const userBalanceQueryOptions = queryOptions({
  queryKey: ["user", "planBalance"],
  async queryFn() {
    const res = await getUserBalance();
    const data = await res.json();
    return { res, data };
  },
  select(data) {
    return data.data;
  },
  // refetchInterval: 5 * 1000,
});

export function useUserBalance() {
  return useQuery(userBalanceQueryOptions);
}
